import { render, staticRenderFns } from "./campusSpecial.vue?vue&type=template&id=3bda569c&scoped=true"
import script from "./campusSpecial.vue?vue&type=script&lang=js"
export * from "./campusSpecial.vue?vue&type=script&lang=js"
import style0 from "./campusSpecial.vue?vue&type=style&index=0&id=3bda569c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bda569c",
  null
  
)

export default component.exports